<template>
    <div class="lesson">
      <div class="lesson-top">
        <div class="lessonTitle">{{ props.data.titleCn }}</div>
        <div class="lessonEn">{{ props.data.titleEn }}</div>
      </div>
      <van-swipe :autoplay="3000" class="swipe">
        <van-swipe-item v-for="(item, index) in props.data.list" :key="index">
          <div class="lesson-list">
            <div class="lesson-item" v-for="(itema,indexa) in item.list" @click="showVideo(itema)" :key="indexa">
              <img class="item-img" :src="itema.pic" alt="" />
              <div class="item-desc">
                <div class="desc-text">{{itema.desc}}</div>
                <img src="https://p5.ssl.qhimg.com/t110b9a9301d77bf49d5dec456d.png" alt="" class="desc-img" />
              </div>
            </div>
          </div>
        </van-swipe-item>
      </van-swipe>
      <el-dialog
        v-if="videoDialogVisible"
        v-model="videoDialogVisible"
        width="100%"
        :show-close="false"
        :close-on-click-modal="true"
        :close-on-press-escape="true"
        align-center
      >
        <video
          autoplay
          controls
          style="width: 100%; height: auto; display: block"
          :src="currentVideo"
        ></video>
      </el-dialog>
    </div>
</template>

<script setup>
import { ref } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/swiper-bundle.css'

const props = defineProps({
  data: {
    type: Object,
    default: {}
  }
})

let videoDialogVisible = ref(false)
let currentVideo = ref('')

const showVideo = (item) => {
  currentVideo.value = item.video
  videoDialogVisible.value = true
}

</script>

<style lang="scss" scoped>
  .lesson {
    opacity: 1;
    padding: 72px 20px 0px;
    .lesson-top{
      display: flex;
      flex-direction: column;
      align-items: center;
      .lessonTitle {
        color: rgb(44, 44, 44);
        font-family: Source Han Sans;
        font-size: 32px;
        font-weight: 700;
        line-height: 32px;
        letter-spacing: 0px;
        text-transform: uppercase;
      }
      .lessonEn {
        color: rgb(44, 44, 44);
        font-family: Rubik;
        font-size: 14px;
        font-weight: 400;
        line-height: 14px;
        letter-spacing: 0px;
        text-transform: uppercase;
        margin-top: 12px;
      }
    }
    .lesson-list{
      width: 100%;
      display: flex;
      flex-direction: column;
      margin-top: 32px;
      .lesson-item{
        width: 100%;
        position: relative;
        margin-bottom: 14px;
        border-radius: 12px;
        overflow: hidden;
        .item-img{
          cursor: pointer;
          width: 100%;
          // height: 280px;
        }
        .item-desc{
          cursor: pointer;
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 36px;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 12px;
          .desc-text{
            color: #fff;
            font-size: 12px;
            line-height: 36px;
            text-align: left;
            font-weight: 700;
          }
          .desc-img{
            width: 24px;
            height: 24px;
          }
        }
      }
    }
    /* 去除对话框 padding */
    :deep(.el-dialog) {
      padding: 0;
      background: none;
    }
    :deep(.el-dialog__header) {
      padding-bottom: 0;
    }
    :deep(.van-swipe__indicators) {
      position: relative;
      margin-top: 20px;
      justify-content: center;
    }
    .swipe {
      --van-swipe-indicator-active-background: #525966;
      --van-swipe-indicator-inactive-background: #dfe1e6;
      --van-swipe-indicator-size: 8px;
    }
  }
</style>
